import BaseController from '../base-controller'

class ListItemController extends BaseController {
  getValue = model => {
    const content = this.getContentController()
    const obj = {
      ...model,
      parent: content.model
    }
    return obj
  }
}

export default ListItemController
